export enum AjaxState {
    initial, pending, success, error
}
